import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiClient } from '../utils/apiClient';
import { BFF_URL } from '../../constant/stringConstants';
import './popupOrder.css';

const apiClient = new ApiClient(BFF_URL);

export default function PopupOrder() {
    const { orderReferenceId } = useParams();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const fetchOrderAndNotifyOpener = async () => {
            try {
                // Fetch cXML response from BFF
                const response = await apiClient.get(`/order/generate-cxml-response/${orderReferenceId}`);
                
                if (response && response.content && response.returnUrl) {
                    setStatus('success');
                    
                    // Send data to opener (landing page) via postMessage
                    if (window.opener && !window.opener.closed) {
                        window.opener.postMessage({
                            returnUrl: response.returnUrl,
                            content: response.content
                        }, '*');
                        
                        // Close popup after a short delay to ensure message is sent
                        setTimeout(() => {
                            window.close();
                        }, 500);
                    } else {
                        // Opener is not available - show manual close message
                        setErrorMessage('The parent window is not available. Please close this window manually and check your procurement system.');
                    }
                } else {
                    setStatus('error');
                    setErrorMessage('Invalid response from server. Please try again.');
                }
            } catch (error) {
                console.error('Error fetching order CXML:', error);
                setStatus('error');
                setErrorMessage(error.message || 'Failed to fetch order data. Please try again.');
            }
        };

        fetchOrderAndNotifyOpener();
    }, [orderReferenceId]);

    const handleManualClose = () => {
        window.close();
    };

    return (
        <div className="popup-order">
            {status === 'loading' && (
                <div className="message">
                    <p>Submitting your data, please wait...</p>
                    <div className="spinner"></div>
                </div>
            )}

            {status === 'success' && (
                <div className="thankyou">
                    <p>Thank you for shopping with us.</p>
                    <br />
                    <a href="#" onClick={(e) => { e.preventDefault(); handleManualClose(); }}>
                        Click here
                    </a>{' '}
                    to close this window
                    <br />
                    and return to your procurement system.
                </div>
            )}

            {status === 'error' && (
                <div className="error">
                    <p className="error-title">Something went wrong</p>
                    <p className="error-message">{errorMessage}</p>
                    <br />
                    <a href="#" onClick={(e) => { e.preventDefault(); handleManualClose(); }}>
                        Click here to close this window
                    </a>
                </div>
            )}
        </div>
    );
}
